import React from 'react';
import { FaAward, FaUsers, FaGlobeAmericas, FaHandshake } from 'react-icons/fa';
import './About.css';

function About() {
  return (
    <main className="about-page">
      <section className="about-hero">
        <div className="container">
          <h1>About V&R Courier Ltd</h1>
          <p>Professional and reliable logistics company serving the UK and Europe</p>
        </div>
      </section>

      <section className="about-content">
        <div className="container">
          <div className="about-intro">
            <h2>Who We Are</h2>
            <p>
              V&R Courier Ltd is a professional and reliable logistics company providing nationwide and
              European delivery solutions. We specialise in urgent same-day deliveries, scheduled
              routes, multi-stop distribution, commercial freight movements, and house removals. With
              a strong focus on customer satisfaction, our team ensures every shipment is handled
              safely, securely, and on time.
            </p>
            <p>
              We operate 24/7 and are equipped to manage anything from small parcel delivery to fullload transport requirements. Our commitment to excellence, combined with a dedicated team of professionals,
              enables us to deliver exceptional service to businesses and individuals across the UK and Europe.
            </p>
          </div>

          <div className="company-info-box">
            <h3>Company Information</h3>
            <div className="info-items">
              <div className="info-item">
                <strong>Company Name:</strong> V&R Courier Ltd
              </div>
              <div className="info-item">
                <strong>Company Number:</strong> 15516419
              </div>
              <div className="info-item">
                <strong>VAT Number:</strong> 471529383
              </div>
              <div className="info-item">
                <strong>Coverage:</strong> Nationwide UK & European Transport
              </div>
              <div className="info-item">
                <strong>Availability:</strong> 24/7 Service
              </div>
            </div>
          </div>

          <div className="values-section">
            <h2 className="section-title">Why Choose V&R Courier Ltd</h2>
            <div className="values-grid">
              <div className="value-card">
                <div className="value-icon">
                  <FaAward />
                </div>
                <h3>24/7 Availability</h3>
                <p>Always ready when you need us. Round-the-clock service ensures your urgent deliveries are never delayed.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">
                  <FaUsers />
                </div>
                <h3>Nationwide Coverage</h3>
                <p>Reaching every corner of the UK, plus Europe-wide transport for international shipping needs.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">
                  <FaGlobeAmericas />
                </div>
                <h3>Dedicated Delivery</h3>
                <p>Your goods travel directly, with no co-loading. Ensuring faster delivery and maximum security.</p>
              </div>
              <div className="value-card">
                <div className="value-icon">
                  <FaHandshake />
                </div>
                <h3>Fast & Reliable</h3>
                <p>We prioritise timely deliveries every time with professional, trained, and uniformed teams.</p>
              </div>
            </div>
          </div>

          <div className="additional-benefits">
            <h2 className="section-title">What Sets Us Apart</h2>
            <div className="benefits-list">
              <div className="benefit-item">
                <h3>Real-Time Updates & Tracking</h3>
                <p>Know where your shipment is at every stage with our live tracking system.</p>
              </div>
              <div className="benefit-item">
                <h3>Professional Team</h3>
                <p>Trained, uniformed and experienced drivers and handlers ensure your goods are in safe hands.</p>
              </div>
              <div className="benefit-item">
                <h3>Flexible Solutions</h3>
                <p>From half-day to full-day hire, same-day to scheduled routes - we adapt to your needs.</p>
              </div>
              <div className="benefit-item">
                <h3>Versatile Fleet</h3>
                <p>Wide range of vehicles from small vans to Luton vans and curtain-side vehicles for all cargo types.</p>
              </div>
              <div className="benefit-item">
                <h3>Secure Handling</h3>
                <p>All vehicles maintained to high safety standards with proper equipment for fragile and heavy items.</p>
              </div>
              <div className="benefit-item">
                <h3>Competitive Pricing</h3>
                <p>Transparent, fair pricing with no hidden costs. Volume discounts available for regular customers.</p>
              </div>
            </div>
          </div>

          <div className="service-areas">
            <h2 className="section-title">Service Coverage</h2>
            <div className="coverage-grid">
              <div className="coverage-card">
                <h3>Nationwide UK</h3>
                <p>Complete coverage across England, Scotland, Wales, and Northern Ireland with rapid response times.</p>
              </div>
              <div className="coverage-card">
                <h3>European Transport</h3>
                <p>Door-to-door road freight solutions across Europe for commercial and time-sensitive shipments.</p>
              </div>
              <div className="coverage-card">
                <h3>Import & Export</h3>
                <p>Reliable international freight handling via air, sea, and road with customs clearance support.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default About;
